import { Movie } from '../models/movie';

const movies: Movie[] = [
  {
    id: "Penkowskiy",
    name: "Penkowskiy: Echoes of Cold War",
    cover: "covers/penkowskiy.jpg",
    requiresAuth: false,
    citations: true,
    dates: {
      planningStart: new Date("2025-06-09"),
      planningEnd: new Date("2025-09-28"),
      shootingStart: new Date("2025-10-12"),
      shootingEnd: new Date("2025-11-23"),
      published: new Date("2026-06-28")
    },
    links: {
      movie: "https://www.youtube.com/embed/pZkGxwDxjx8",
      makingOf: "https://www.youtube.com/embed/YMWIq30OVH0",
      trailer: "https://www.youtube.com/embed/5BPfu9OIsKU?si=OmbOJTEBM11ICzyZ",
    }
  },
  {
    id: "Bonnie-and-Clyde",
    name: "Bonnie & Clyde: Im Schatten der Freiheit",
    cover: "covers/bonnie-and-clyde.jpg",
    requiresAuth: false,
    citations: true,
    dates: {
      planningStart: new Date("2023-10-01"),
      planningEnd: new Date("2024-08-01"),
      shootingStart: new Date("2024-08-04"),
      shootingEnd: new Date("2024-08-31"),
      published: new Date("2025-01-10")
    },
    links: {
      movie: "https://www.youtube.com/embed/XeOFP9qvEQE?si=o5Tcs4R8chskS9bP",
      makingOf: "https://www.youtube.com/embed/A_FM1JBNSok?si=CiG5M5QREF2tl7yq",
      trailer: "https://www.youtube.com/embed/L550nVo7yg4?si=__ku5R5JPKYS0DiH",
      teaser: "https://www.youtube.com/embed/3Cqy8s5PHXk?si=zsvtYzHNuxR5FxT_"
    }
  },
  {
    id: "Looped",
    name: "Looped - the changing path",
    cover: "covers/looped.jpg",
    requiresAuth: false,
    citations: true,
    dates: {
      planningStart: new Date("2022-09-01"),
      planningEnd: new Date("2023-03-01"),
      shootingStart: new Date("2023-03-08"),
      shootingEnd: new Date("2024-04-05"),
      published: new Date("2023-09-21")
    },
    links: {
      movie: "https://www.youtube.com/embed/TjqHTmJRSoU?si=qcXrncZooSKRB5Ht",
      makingOf: "https://www.youtube.com/embed/NwNITUj8Ijg?si=egeINKQwYG0ax77B",
      trailer: "https://www.youtube.com/embed/eaR-tfA3flE?si=MHSWctomiCRKQYdT",
      teaser: "https://www.youtube.com/embed/_Q2DYyJg1FU?si=ab-yrMEzbb1GzyFIs"
    }
  },
  {
    id: "mission-carasau",
    name: "mission carasau",
    cover: "covers/mission-carasau.jpg",
    requiresAuth: true,
    citations: false,
    dates: {
      planningStart: new Date("2019-04-01"),
      planningEnd: new Date("2019-09-20"),
      shootingStart: new Date("2019-07-01"),
      shootingEnd: new Date("2020-04-01"),
      published: new Date("2020-12-06")
    },
    links: {
      movie: "https://www.youtube.com/embed/QCFMNJevAFg?si=QZO2DiV1pPCr7Cm0",
      makingOf: "https://www.youtube.com/embed/r28w5xRnHHE?si=FN_ivkkuGhUG3Ezq",
      trailer: "https://www.youtube.com/embed/YuigihjmMq8?si=zj9la8B9WZYdball",
    }
  },
  {
    id: "Deadline",
    name: "Deadline - Das Ultimatum",
    cover: "covers/deadline.jpg",
    requiresAuth: true,
    citations: false,
    dates: {
      planningStart: new Date("2018-07-01"),
      planningEnd: new Date("2018-09-01"),
      shootingStart: new Date("2018-09-15"),
      shootingEnd: new Date("2019-04-01"),
      published: new Date("2019-08-16")
    },
    links: {
      movie: "https://www.youtube.com/embed/5G8LkbK0A74?si=8i98DXS-4iKW8_lv",
      makingOf: "https://www.youtube.com/embed/h0v9QTV75gY?si=o75WrtfinutpxkCd",
      trailer: "https://www.youtube.com/embed/lx4q7VVJEgo?si=B4UeWMlSyp5VfoBk",
    }
  }
];

export function getLatestMovie(onlyPublished: boolean = true) {
  return onlyPublished
    ? getMovies(true).sort(sortByDateDesc())[0]
    : movies.sort(sortByDateDesc())[0];
}

export function getMovies(onlyPublished: boolean = true, onlyFreeAccess: boolean = false): Movie[] {
  return onlyPublished
    ? movies
      .filter(movie => movie.dates.published.valueOf() <= Date.now())
      .filter(movie => onlyFreeAccess ? movie.requiresAuth === false : true)
    : movies;
}

export function sortByDateDesc(): (a: Movie, b: Movie) => number {
  return (a, b) => b.dates.published.valueOf() - a.dates.published.valueOf();
}